<template >
    <div class="droplayer relative right list">
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="getBoardList()">{{boardListCount}}</v-btn>
            </template>
            <div class="dropdown-list">
                <div class="top" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: boardList.length})"></div>
                <div class="scroll">
                    <div class="list_box">
                        <ul> 
                            <li v-for="(board , idx) in boardList" :key="'board_'+idx" >
                                <button type="button" class="ell-singleline" @click="moveBoard(board)">
                                    {{board.paperTitle}} 
                                </button>
                                <div class="dividing_line_ty2"></div>
                                <span class="name">{{ defaultLanguage.indexOf('ko') != -1 ? board.regUserName : board.regUserNameEn != null ? board.regUserNameEn : board.regUserName }}</span>
                                <div class="dividing_line_ty2"></div>
                                <span class="date"><momentAgo  prefix="" suffix="전" :date="board.lastUpdDate"  lang="kr"></momentAgo></span>
                            </li>  
                        </ul>
                    </div>
                </div>
            </div>
        </v-menu>
    </div> 
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Vue from "vue";
export default {
    props:["item", "boardListCount"],
    data(){
        return{
            boardList:[],
            firstCall:true,

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        }
    },
    methods:{ 
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION" ]),  
        // 회의/협의체 카테고리당 보드 리스트 
        getBoardList(){ 
            if(this.boardList.length == 0 && this.firstCall){ 
                event.target.parentElement.classList.add('active'); 
                let obj = this;
                let reqData = {};
                reqData.params ={ 
                    categoryMid : this.item.categoryMid
                }
                reqData.req = obj.req;
                reqData.url = "/api/copaper/cooperation/getBoardList";
                reqData.method = "post";
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                    obj.boardList = res.result;
                })
                .catch(function(err) {
                    console.log(err);
                });  
                this.firstCall =false;
            }
        },
        moveBoard(board){
            // event.target.parentElement.parentElement.parentElement.parentElement.parentElementclassList.remove('active');
            let path = "/general/board/" + board.paperId;
            this.$router.push(path);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/manage/components/CooperationBoardList.vue